export default "__VITE_ASSET__Dpo$YMiJ__"